import { render } from "./DefenseMobile.vue?vue&type=template&id=61380030"
import script from "./DefenseMobile.vue?vue&type=script&lang=js"
export * from "./DefenseMobile.vue?vue&type=script&lang=js"

import "./DefenseMobile.vue?vue&type=style&index=0&id=61380030&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__